import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Container } from '@nfs-react/components';
import { useText } from 'hooks';
import { MOBILE, TABLET, DESKTOP } from 'helpers/styles/media';
import FormMain from '../Form/FormMain';

const Bottom = ({ formRef }) => {
  return (
    <BottomBlock ref={formRef}>
      <Container>
        <Title>{useText('bottom__title', true)}</Title>
        <FormMain />
      </Container>
    </BottomBlock>
  );
};

const BottomBlock = styled.div`
  position: relative;
  background-position: center top;
  background-repeat: no-repeat;

  @media ${DESKTOP} {
    min-height: 539px;
    padding-top: 22px;
    background-position: center;
    background-size: 1920px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('bottom-bg-d.jpg')};
  }

  @media ${TABLET} {
    padding-top: 40px;
    min-height: 587px;
    background-position: center;
    background-size: 1199px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('bottom-bg-d.jpg')};
  }

  @media ${MOBILE} {
    padding-top: 30px;
    min-height: 685px;
    background-position: center;
    background-size: 767px 100%;
    background-image: ${({ theme: { imgUrl } }) => imgUrl('bottom-bg-d.jpg')};
  }
`;

const Title = styled.div`
  font-weight: 500;
  font-size: 37px;
  line-height: 54px;
  text-align: center;
  color: #cbbf9e;
  padding: 0 100px;
  margin-bottom: 45px;

  @media ${TABLET} {
    padding: 0;
    margin-bottom: 38px;
  }

  @media ${MOBILE} {
    padding: 0;
  }
`;

Bottom.propTypes = {
  formRef: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.shape({
      current: PropTypes.shape({ root: PropTypes.string.isRequired }),
    }),
  ]).isRequired,
};

export default Bottom;
